var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", [
      _vm._v(_vm._s(_vm.$t("InvestmentReport.Finances.Funding.Title")))
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t("InvestmentReport.Finances.Funding.FundingSupportApartments")
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "InvestmentReport.Finances.Funding.FundingSupportApartments_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _c("ul", [
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t("InvestmentReport.Finances.Funding.SelfCoveredFunding")
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t("InvestmentReport.Finances.Funding.OtherGovernmentAid")
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(_vm.$t("InvestmentReport.Finances.Funding.AppliedAid"))
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ml-3" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.Funding.SelfCoveredFunding_Details"
            )
          )
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ml-3" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.Funding.OtherGovernmentAid_Details"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.Funding.OtherGovernmentAid_Details_Instructions"
            )
          )
        )
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "InvestmentReport.Finances.Funding.SelfCoveredFundingLoanCondition"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("b", [_vm._v(_vm._s(_vm.$t("Enums.PledgeType.GeneralPledge")))])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [_vm._v(_vm._s(_vm.$t("Enums.PledgeType.SpecialPledge")))])
      ]),
      _vm._v(" "),
      _c("li", [_c("b", [_vm._v(_vm._s(_vm.$t("Enums.PledgeType.None")))])])
    ]),
    _vm._v(" "),
    _c("h3", [
      _vm._v(_vm._s(_vm.$t("InvestmentReport.Finances.Expenses.Title")))
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Section")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(_vm.$t("InvestmentReport.Finances.ApartmentAcquisitions.Title"))
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "InvestmentReport.Finances.ApartmentAcquisitions.Title_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ml-5" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "BudgetaryEstimate.Investment.SupportApartments.Apartment.TargetGroup"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.TargetGroupInstructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.PriceRuleIsCleared"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.PriceRuleIsCleared_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.FreeOfDebtPrice"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.TransferTax"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.RepairCosts"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.YearOfAcquisition"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.YearOfAcquisition_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t("InvestmentReport.Finances.ApartmentAcquisitions.PledgeType")
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.PledgeType_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t("InvestmentReport.Finances.ApartmentAcquisitions.RentType")
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.RentType_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.RentPerSquareMeter"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.RentPerSquareMeter_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(_vm.$t("InvestmentReport.Finances.ApartmentAcquisitions.Size"))
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.Size_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.ApartmentRooms"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.ApartmentRooms_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.ConstructionYear"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.ConstructionYear_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.TypeOfHousing"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.TypeOfHousing_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t("InvestmentReport.Finances.ApartmentAcquisitions.BusinessId")
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.BusinessId_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.ShareGroupId"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.ShareGroupId_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.RealEstateId"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.ApartmentAcquisitions.RealEstateId_Instructions"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("InvestmentReport.BasicInfo.Address.Postal")))
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("InvestmentReport.BasicInfo.Address.PostalCode")))
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("InvestmentReport.BasicInfo.Address.City")))
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("h3", { staticClass: "mt-0" }, [
      _vm._v(_vm._s(_vm.$t("InvestmentReport.Finances.Attachments.Title")))
    ]),
    _vm._v(" "),
    _c("div", [
      _c("ul", [
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "InvestmentReport.Finances.Attachments.SupportApartmentBalanceSheet"
                )
              )
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }